import { render, staticRenderFns } from "./POPSingle.vue?vue&type=template&id=4a3087ea&scoped=true"
import script from "./POPSingle.vue?vue&type=script&lang=js"
export * from "./POPSingle.vue?vue&type=script&lang=js"
import style0 from "./POPSingle.vue?vue&type=style&index=0&id=4a3087ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3087ea",
  null
  
)

export default component.exports